var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSeparator = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 220,
  height: 8,
  viewBox: "0 0 220 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.606368L12.0989 0.408203V2.70461L0 2.50645V0.606368Z",
  fill: "black"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4168 -6.10352e-05L35.7272 0.163135L35.7122 2.22639L26.4018 2.308L26.4168 -6.10352e-05Z",
  fill: "black"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.2266 0.804161C51.1696 0.559367 55.1426 0.571028 59.0856 0.82748L58.8757 3.03063C55.0826 2.83247 51.2595 2.86743 47.4814 3.13554L47.2266 0.804161Z",
  fill: "black"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3093 2.00592C78.0515 2.21574 83.7786 2.33232 89.5357 2.34398L89.4608 4.3373C83.7336 4.08085 77.9915 3.91766 72.2494 3.85938L72.3243 2.00592H72.3093Z",
  fill: "black"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M105.127 2.86712L120.48 2.85547L120.45 5.15188L105.097 4.87211L105.127 2.86712Z",
  fill: "black"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M138.516 4.1723L153.868 4.23059V6.11902L138.516 6.17729V4.1723Z",
  fill: "black"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M168.336 4.97705C173.823 5.36173 179.355 5.47831 184.873 5.31511L185.008 7.89127C179.355 8.08944 173.673 8.0195 168.036 7.65814L168.336 4.97705Z",
  fill: "black"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M203.103 4.85024C208.726 4.6171 214.378 4.58214 220 4.76865L219.895 6.93683C214.348 6.79695 208.801 6.85522 203.268 7.12333L203.103 4.85024Z",
  fill: "black"
})));
export default SvgIconSeparator;